if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    // Évite de refaire l'appel (et le clignotement) à chaque reconstruction du tiroir
    static cache = new Map();

    get cacheKey() {
      return `${this.dataset.url}|${this.dataset.cartKey}`;
    }

    connectedCallback() {
      const cached = CartRecommendations.cache.get(this.cacheKey);
      if (cached !== undefined) return this.render(cached);

      // Chargement différé : uniquement quand le tiroir est ouvert et le bloc visible
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 300px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    load() {
      const key = this.cacheKey;
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const inner = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.cart-recommendations__inner');
          const content = inner ? inner.innerHTML.trim() : '';
          CartRecommendations.cache.set(key, content);
          if (this.isConnected) this.render(content);
        })
        .catch((error) => console.error(error));
    }

    render(content) {
      this.innerHTML = content;
      this.track = this.querySelector('.cart-recommendations__track');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-direction="prev"]');
      this.nextButton = this.querySelector('[data-direction="next"]');
      this.prevButton.addEventListener('click', () => this.slide(-1));
      this.nextButton.addEventListener('click', () => this.slide(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    slide(direction) {
      const slide = this.track.querySelector('.cart-recommendations__slide');
      if (!slide) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (slide.offsetWidth + gap), behavior: 'smooth' });
    }

    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.classList.toggle('is-static', max <= 0);
      this.prevButton.disabled = this.track.scrollLeft <= 0;
      this.nextButton.disabled = this.track.scrollLeft >= max;
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}